<template>
  <v-container fluid>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :top="true"
      :right="true"
      :timeout="-1"
      absolute
    >
      {{ message }}
      <v-btn
        dark
        text
        @click="snackbar = false"
      >
        CLOSE
      </v-btn>
    </v-snackbar>
    <v-row class="d-flex justify-space-between align-center" style="padding: 0 !important;">
      <v-col cols="auto" style="padding: 10px !important;">
        <h5 style="font-weight: bold"> Due Deligence Statement </h5>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="auto" v-if="canUploadCatalogue" style="padding: 0 !important;">
        <v-btn class="custom-btn" @click="openLocationDialog">Upload Catalogue</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" style="padding: 10px !important; margin-top: 15px">
        <div class="elevation-4" :style="{ backgroundColor: '#FFFFFF'}" style="padding: 0 !important;">
          <v-card-text style="padding-bottom: 0 !important;">

            <v-row class="d-flex justify-space-between align-center">
              <v-col cols="12" md="2">
                <v-text-field v-model="lotValue" label="Lot" outlined dense></v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field v-model="saleValue" label="Sale" outlined dense></v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field v-model="seasonValue" label="Season" outlined dense></v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field v-model="warrantValue" label="Warrant" outlined dense></v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field v-model="eslipValue" label="Eslip" outlined dense></v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <v-btn style="margin-top: -30px" block color="primary" outlined @click="submitTopQuery(0)">Search</v-btn>
              </v-col>
            </v-row>
            <hr>
<!--            <v-row class="d-flex justify-space-between align-center">
              <v-col cols="12" md="4">
                <v-text-field v-model="eslipValue" label="Eslip Number" outlined dense></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field v-model="warrantValue" label="Warrant Number" outlined dense></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-btn style="margin-top: -30px" @click="submitEslipWarrant(0)" block color="primary" outlined>Search</v-btn>
              </v-col>
            </v-row>-->
            <div class="table-responsive">
              <table class="table">
                <thead class="thead">
                <tr>
                  <th scope="col">Grower</th>
                  <th scope="col">Broker</th>
                  <th scope="col">Coordinates</th>
                  <th scope="col">Forest Proximity</th>
                  <th scope="col">Protected Area</th>
                  <th scope="col">Action</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="file in filteredList" v-bind:key="file.id">
                  <td>{{ file.growerCode }}</td>
                  <td>{{ file.brokerCode }}</td>
                  <td @click="openLocationDialog">{{ file.coordinateOne }}</td>
                  <td>{{ file.forestProximity }}</td>
                  <td>{{ file.protectedArea }}</td>
                  <td class="actions">
                    <v-menu offset-y>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          color="primary"
                          v-on="on"
                          text
                          icon
                          
                        >
                          <v-icon small> more_horiz </v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item @click="downloadDuediligence(file)">
                          <v-list-item-title> Download </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </v-card-text>
          <v-card-actions style="margin: 0 !important; padding: 0 !important;">
            <v-col cols="12" class="d-flex flex-column flex-md-row justify-space-between align-center" style="padding: 0 !important;">
              <span class="paginationtext" style="padding-left: 10px"> Showing {{ page }} of {{ numberOfLinks }} pages </span>
              <v-spacer></v-spacer>
              <v-pagination
                v-model="page"
                :length="numberOfLinks"
                :total-visible="4"
                color="secondary"
                class="accent--text logoutbtn"
              ></v-pagination>
            </v-col>
          </v-card-actions>
        </div>
      </v-col>
      <v-dialog v-model="openLocDialog" persistent max-width="800">
        <v-card>
          <v-card-title class="headline accent--text">Location</v-card-title>
          <v-card-text>
            <div id="map-container" style="width: 100%; height: 500px;"></div>
          </v-card-text>
          <v-card-actions>
            <v-btn outlined color="primary"  @click="openLocDialog = false">
              Cancel
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn class="custom-btn" style="font-weight: 600;" @click="uploadCatalogueDialog">Accept</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'
import { Common } from '@/components/views/file/common'
import { prettyDate } from '../../../filters'

export default {
  name: 'catalogueupload',
  data: function () {
    return {
      previewItems: [],
      valid: true,
      message: '',
      snackbar: false,
      snackbarColor: '',
      file: '',
      files: [],
      totalFiles: 0,
      pagination: {
        sortBy: 'id',
        descending: true
      },
      loading: false,
      latitude: 37.7749, // Default latitude
      longitude: -122.4194, // Default longitude
      map: null,
      search: '',
      expand: false,
      permissions: [],
      timerContent: true,
      previewLoading: false,
      approveloading: false,
      declineloading: false,
      paginatedFiles: [],
      numberOfLinks: 0,
      numberOfItemsPerPage: window.innerHeight <= 600 ? 6 : window.innerHeight > 600 && window.innerHeight <= 1000 ? 14 : 20,
      page: 1,
      currentPage: 0,
      confirmDialog: false,
      confirmDeleteDialog: false,
      confirmFile: {},
      confirmMessage: '',
      action: '',
      uploadFileDialog: false,
      remainingTime: 0, // Total time in days
      interval: null,
      targetDate: '',
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      saleNo: '',
      lotValue: '',
      saleValue: '',
      seasonValue: '',
      growerValue: '',
      brokerValue: '',
      eslipValue: '',
      warrantValue: '',
      saleDate: '',
      isUploadDisabled: false,
      openLocDialog: false,
      showProgressBar: false
    }
  },
  mounted () {
    console.log(window.innerHeight)
    //this.getSeasons(this.currentPage)
    this.permissions = store.state.user.roleId.permissions
    this.startCountdown()
   // this.submitEslipWarrant(this.currentPage)
  },
  beforeDestroy () {
    clearInterval(this.interval)
  },
  watch: {
    files () {
      this.paginatedFiles = this.files

      // this.paginatedFiles = this.paginationMethod(this.files, 1, this.numberOfItemsPerPage)
      // this.numberOfLinks = Math.ceil(this.files.length / this.numberOfItemsPerPage)
    },
    page: function (val) {
      // this.paginatedFiles = this.paginationMethod(this.files, val, this.numberOfItemsPerPage)
      this.paginatedFiles = this.getUploadedFiles(val - 1)
    }
  },
  computed: {
    canUploadCatalogue: function () {
      return this.hasPerm('CAN_UPLOAD_CATALOGUE')
    },
    canApproveCatalogue: function () {
      return this.hasPerm('CAN_APPROVE_CATALOGUE')
    },
    filteredList: function () {
      if (this.search === '') {
        return this.paginatedFiles
      } else {
        return this.files.filter(file => {
          const searchTerm = this.search.toLowerCase()
          var dateCreated = new Date(file.created)
          return (
            (file.fileName.toLowerCase().includes(searchTerm)) ||
            file.totalBags.toString().includes(searchTerm) ||
            file.totalWeight.toString().includes(searchTerm) ||
            file.status.statusName.toLowerCase().includes(searchTerm) ||
            file.createdBy.toLowerCase().includes(searchTerm) ||
            dateCreated.toDateString().toLowerCase().includes(searchTerm)
          )
        })
        // return this.files.filter(file => { return file.fileName.toLowerCase().includes(this.search.toLowerCase()) })
      }
    }
  },
  methods: {
    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long', // e.g., "September"
        day: 'numeric', // e.g., "15"
      });
    },
    startCountdown () {
      this.interval = setInterval(this.updateCountdown, 1000)
    },
    canBeApproved (item) {
      return (item.status.id === 3 || item.status.id === 0) && this.hasPerm('CAN_APPROVE_CATALOGUE')
    },
    auctionFile (item) {
      return item.status.statusName === 'APPROVED'
    },
    canBeDeclined (item) {
      return item.status.id === 3 && this.hasPerm('CAN_APPROVE_CATALOGUE')
    },
    submitTopQuery (page) {
      if (this.lotValue === '' && this.saleValue === ''
        && this.seasonValue === '' && this.warrantValue === ''
        && this.eslipValue === ''){
        this.message = "Please enter at least one field"
        this.snackbar = true
        this.snackbarColor = 'error'
        return
      }
      var url = config.serverURI + '/udr/duediligencetopquery?page=' + page +
        '&size=' + this.numberOfItemsPerPage + '&paginate=Y'+'&lotNumber='+this.lotValue+'&saleNumber='+this.saleValue+'&season='+this.seasonValue+'&warrantNumber='+this.warrantValue+'&eslipNumber='+this.eslipValue
      axios.get(url)
        .then(response => {
          this.files = response.data.content
          console.log('----->>>>>>>>>22 ', response.data.content)
          console.log('----->>>>>>>>> ', this.files)
          // this.numberOfLinks = response.data.totalPages
          // this.numberOfItemsPerPage = response.data.size
          // this.currentPage = response.data.number
          // this.files = response.data.content
          // console.log('----->>>>>>>>> ',this.files)
          // this.numberOfLinks = response.data.page.totalPages
          // this.numberOfItemsPerPage = response.data.page.size
          // this.currentPage = response.data.page.number
        })
        .catch(error => {
          // Request failed.
          console.log('error', error.response)
        })
      return this.files
    },
    submitEslipWarrant (page) {
      if (this.eslipValue === '' || this.warrantValue === ''){
        this.message = "Please enter eslip and warrant"
        this.snackbar = true
        this.snackbarColor = 'error'
        return
      }
      var url = config.serverURI + '/udr/duediligence?page=' + page +
        '&size=' + this.numberOfItemsPerPage + '&paginate=Y'+'&eslip='+this.eslipValue+'&warrant='+this.warrantValue
      axios.get(url)
        .then(response => {
          this.files = response.data.content
          console.log('----->>>>>>>>>22 ', response.data.content)
          console.log('----->>>>>>>>> ', this.files)
          // this.numberOfLinks = response.data.totalPages
          // this.numberOfItemsPerPage = response.data.size
          // this.currentPage = response.data.number
          // this.files = response.data.content
          // console.log('----->>>>>>>>> ',this.files)
          // this.numberOfLinks = response.data.page.totalPages
          // this.numberOfItemsPerPage = response.data.page.size
          // this.currentPage = response.data.page.number
        })
        .catch(error => {
          // Request failed.
          console.log('error', error.response)
        })
      return this.files
    },
    downloadDuediligence (item) {
      const url = config.serverURI + '/udr/download'
      axios({ url: url, method: 'POST', responseType: 'blob', data: item})
        .then(response => {
          console.log('item --> ', item);
          const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
          const link = document.createElement('a')
          link.href = url
         // const output_string = item.growerCode.replace("/", "")
          //onst itemFileName = output_string +'_'+item.growerCode+'_'+item.brokerCode+'.pdf'
          const itemFileName = item.growerCode+'_'+item.brokerCode+'.pdf'
          link.setAttribute('download', itemFileName)
          document.body.appendChild(link)
          link.click()
        })
        .catch(error => {
          // Request failed.
          console.log('error', error.response)
          this.message = 'Error occurred'
          this.snackbar = true
          this.snackbarColor = 'error'
        })
    },
    paginationMethod (items, pageNumber, limitPerPage) {
      pageNumber = pageNumber - 1
      const from = pageNumber * limitPerPage
      let to = (pageNumber + 1) * limitPerPage
      if (to >= items.length) {
        to = items.length
      }
      return items.slice(from, to)
    },
    hasPerm (permission) {
      return this.permissions.includes(permission)
    },
    handleFileUpload () {
      this.file = this.$refs.file.files[0]
    },
    uploadCatalogueDialog () {
      this.openLocDialog = false
      this.uploadFileDialog = true
    },
    openLocationDialog () {
      this.openLocDialog = true
      this.$nextTick(() => {
        this.initializeMap();
      });
    },
    initializeMap() {
      const mapContainer = document.getElementById('map-container');

      if (mapContainer) {
        this.map = new google.maps.Map(mapContainer, {
          center: { lat: this.latitude, lng: this.longitude },
          zoom: 12
        });
      } else {
        console.error('Map container element not found');
      }
    },
  },
}

</script>
<style>

h4 {
  font-size: 15px;
}

h5 {
  font-size: 19px;
  font-weight: bold;
}
.catalogue_box_empty {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.catalogue_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.catalogue_box:after, .catalogue_box:before {
  right: 100%;
  top: 17%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.catalogue_box:after {
  border-color: rgba(255, 255, 255, 0);
  border-right-color: #fff;
  border-width: 20px;
  margin-top: -20px;
}

.catalogue_box:before {
  border-color: rgba(112, 112, 112, 0);
  border-right-color: #707070;
  border-width: 21px;
  margin-top: -21px;
}

.thead {
  background-color: #00513B !important;
  color: white;
  font-size: 12px;
}

.table tbody tr > td.actions {
  font-size: 20px !important;
  color: #733D29 !important;
  padding-top: 0px;
}

.pagination {
  background-color: red;
}

.paginationtext {
  color: #733D29;
}

.pagination > li > a,
.pagination > li > span {
  border: 1px solid #F2D0A7;
  color: #733D29;
}

.pagination > li.active > .page-link {
  background: #00513B;
  color: #fff;
}

.custom-icon {
  font-size: 18px; /* Adjust the size as needed */
}
.table-responsive {
  overflow-x: auto; /* Enable horizontal scrolling */
}

.table {
  min-width: 600px; /* Minimum width to maintain structure */
}

/* Optional: Adjust the size of text on smaller screens */
@media (max-width: 600px) {
  .table td,
  .table th {
    font-size: 12px; /* Adjust font size */
  }
}

.custom-btn {
  color: white !important;
  background-color: #7BC243 !important;
}

h5 {
  color: white;
}

</style>
